import type { ChatTag, WhatsappChat } from "../../types.ts";
import { totalArchived, totalGroups, totalUnread } from "../Chat.helpers.ts";

type Chip = {
  id: string;
  label: string;
  badge: number | null;
  color: string | null;
  tag: ChatTag | null;
};

export function FilterChips({
  active,
  chats,
  tags,
  onSelect,
  onCreateTag,
  onDeleteTag,
}: {
  active: string;
  chats: WhatsappChat[];
  tags: ChatTag[];
  onSelect: (filter: string) => void;
  onCreateTag: () => void;
  onDeleteTag: (tag: ChatTag) => void;
}) {
  const baseChips: Chip[] = [
    { id: "all", label: "Tudo", badge: null, color: null, tag: null },
    { id: "unread", label: "Nao lidas", badge: totalUnread(chats) || null, color: null, tag: null },
    { id: "groups", label: "Grupos", badge: totalGroups(chats) || null, color: null, tag: null },
    { id: "archived", label: "Arquivadas", badge: totalArchived(chats) || null, color: null, tag: null },
  ];
  const tagChips = tags.map((tag): Chip => ({
    id: `tag:${tag.id}`,
    label: tag.name,
    badge: chats.filter((chat) => Array.isArray(chat.tagIds) && chat.tagIds.includes(tag.id)).length || null,
    color: tag.color,
    tag,
  }));
  const chips = baseChips.concat(tagChips);

  return (
    <div className="wa-chips">
      {chips.map((chip) => (
        <button
          key={chip.id}
          className={`wa-chip ${active === chip.id ? "is-active" : ""}`}
          style={chip.color ? { borderLeft: `3px solid ${chip.color}` } : undefined}
          type="button"
          onClick={() => onSelect(chip.id)}
          onContextMenu={chip.tag ? (event) => {
            event.preventDefault();
            onDeleteTag(chip.tag as ChatTag);
          } : undefined}
        >
          <span className="wa-chip-label">{chip.label}</span>
          {chip.badge ? <span className="wa-chip-badge">{chip.badge}</span> : null}
        </button>
      ))}
      <button className="wa-chip wa-chip-add" type="button" title="Criar tag personalizada" onClick={onCreateTag}>
        + Tag
      </button>
    </div>
  );
}
